/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_WorkflowInputs */

const en_mk_foot_workflow = /** @type {(inputs: Mk_Foot_WorkflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow`)
};

const id_mk_foot_workflow = /** @type {(inputs: Mk_Foot_WorkflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alur kerja`)
};

/**
* | output |
* | --- |
* | "Workflow" |
*
* @param {Mk_Foot_WorkflowInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_workflow = /** @type {((inputs?: Mk_Foot_WorkflowInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_WorkflowInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_workflow(inputs)
	return en_mk_foot_workflow(inputs)
});